import { Client } from '@opanuj/shared/types';

export type ClientDraftInput = {
	id?: string;
	fullAccount?: boolean;
	createdAt?: string;
	uid?: string;
	name: string;
	email: string;
	phone?: string;
	address?: string;
	postalCode?: string;
	city?: string;
	billingName?: string;
	billingAddress?: string;
	billingPostalCode?: string;
	billingCity?: string;
	billingNip?: string;
	notes?: string;
	products?: Client['products'];
	productsHistory?: Client['productsHistory'];
	notifications?: { emails: string[] };
};

export const normalizeClientDraft = (input: ClientDraftInput): Partial<Client> => {
	const emailList = Array.from(
		new Set(
			[`${input.email ?? ''}`.trim(), ...(input.notifications?.emails ?? [])]
				.filter(Boolean)
		)
	);

	return {
		id: input.id,
		createdAt: input.createdAt,
		uid: input.uid,
		name: input.name,
		email: input.email,
		phone: input.phone ?? '',
		notes: input.notes ?? '',
		billing: {
			name: input.billingName ?? input.name ?? '',
			address: input.billingAddress ?? input.address ?? '',
			postalCode: input.billingPostalCode ?? input.postalCode ?? '',
			city: input.billingCity ?? input.city ?? '',
			...(input.billingNip ? { nip: input.billingNip } : {}),
		},
		notifications: {
			emails: emailList,
		},
		products: input.products ?? [],
		productsHistory: input.productsHistory ?? [],
		fullAccount: input.fullAccount ?? true,
	};
};
